import React from 'react';
import * as Icons from 'lucide-react';
import Card3D from '../ui/Card3D';
import { Deal } from '../../types/deal';
import DealFeature from './DealFeature';
import DealPrice from './DealPrice';

interface DealCardProps {
  deal: Deal;
}

const DealCard: React.FC<DealCardProps> = ({ deal }) => {
  const IconComponent = Icons[deal.iconName as keyof typeof Icons];

  const handleActivate = () => {
    window.location.href = deal.link;
  };

  return (
    <Card3D>
      <div className="h-full flex flex-col bg-white p-8 rounded-2xl shadow-lg">
        <div className="flex items-center space-x-4 mb-6">
          <div 
            className="w-12 h-12 rounded-xl flex items-center justify-center"
            style={{
              backgroundColor: `${deal.color}15`,
              color: deal.color
            }}
          >
            {IconComponent && <IconComponent className="w-6 h-6" />}
          </div>
          <h3 className="text-xl font-bold" style={{ color: deal.color }}>
            {deal.title}
          </h3>
        </div>

        <p className="text-gray-600 mb-6">{deal.description}</p>

        <div className="space-y-4 mb-6 flex-grow">
          {deal.features.map((feature, index) => (
            <DealFeature key={index} feature={feature} color={deal.color} />
          ))}
        </div>

        <div className="space-y-2">
          <DealPrice label="Prix normal" price={deal.originalPrice} isStrikethrough />
          <DealPrice label="Prix étudiant" price={deal.studentPrice} color={deal.color} isBold />
        </div>

        <button
          onClick={handleActivate}
          className="w-full mt-6 px-6 py-3 rounded-lg text-white transition-all transform hover:scale-105 hover:opacity-90"
          style={{ backgroundColor: deal.color }}
        >
          Activer l'offre
        </button>
      </div>
    </Card3D>
  );
};

export default DealCard;